import { Controller } from 'stimulus';
import { initTemplatePicker } from '../lib/template_picker';

// Upgrades a <select data-controller="template-picker"> rendered by
// TemplatePickerHelper#template_picker_select into the shared template
// picker (lib/template_picker.js). The original <select> stays in the DOM
// with its value in sync, so other controllers' targets and change actions
// on it keep working (Metrics filters, the notification rule form).
export default class extends Controller {
  connect() {
    this.picker = initTemplatePicker(this.element, { placeholder: this.element.dataset.placeholder });
  }

  disconnect() {
    if (this.picker) {
      try { this.picker.destroy(); } catch (_) { /* already gone */ }
      this.picker = null;
    }
  }
}
